module.exports = __webpack_public_path__ + "static/landing-background-633acb0accb0122d19a14c051fdebe8f.mp4";